import { render } from "./app.vue?vue&type=template&id=1b8fd800&bindings={}"
import script from "./app.vue?vue&type=script&lang=js"
export * from "./app.vue?vue&type=script&lang=js"

import "./app.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script